import React from 'react';
import { Link } from 'react-router-dom';
import './ContinueWatching.css';

type ProfileType = 'recruiter' | 'developer' | 'stalker' | 'client';

interface ContinueWatchingProps {
  profile: ProfileType;
}

const continueWatchingConfig = {
  recruiter: [
    { title: "Music", imgSrc: "https://picsum.photos/seed/music/300/200", link: "/music" },
    { title: "Photography", imgSrc: "https://picsum.photos/seed/photography/300/200", link: "/photography" },
    { title: "Blogs", imgSrc: "https://picsum.photos/seed/blogs/300/200", link: "/blogs" },
    { title: "Contact Me", imgSrc: "https://picsum.photos/seed/contact/300/200", link: "/contact-me" }
  ],
  developer: [
    { title: "Music", imgSrc: "https://picsum.photos/seed/dev-music/300/200", link: "/music" },
    { title: "Photography", imgSrc: "https://picsum.photos/seed/dev-photos/300/200", link: "/photography" },
    { title: "Blogs", imgSrc: "https://picsum.photos/seed/dev-blogs/300/200", link: "/blogs" },
    { title: "Certifications", imgSrc: "https://picsum.photos/seed/certs/300/200", link: "/certifications" },
    { title: "Contact Me", imgSrc: "https://picsum.photos/seed/dev-contact/300/200", link: "/contact-me" }
  ],
  stalker: [
    { title: "Top Picks", imgSrc: "https://picsum.photos/seed/top-picks/300/200", link: "/recommendations" },
    { title: "New Releases", imgSrc: "https://picsum.photos/seed/new-releases/300/200", link: "/projects" },
    { title: "Now Playing", imgSrc: "https://picsum.photos/seed/now-playing/300/200", link: "/music" },
    { title: "Watch Again", imgSrc: "https://picsum.photos/seed/watch-again/300/200", link: "/work-experience" }
  ],
  client: [
    { title: "My Freelance Services", imgSrc: "https://picsum.photos/seed/freelance-services/300/200", link: "/skills" },
    { title: "Recent Case Studies", imgSrc: "https://picsum.photos/seed/case-studies/300/200", link: "/projects" },
    { title: "Client Testimonials", imgSrc: "https://picsum.photos/seed/client-testimonials/300/200", link: "/recommendations" },
    { title: "Start a Collaboration", imgSrc: "https://picsum.photos/seed/start-project/300/200", link: "/contact-me" }
  ]
};

const ContinueWatching: React.FC<ContinueWatchingProps> = ({ profile }) => {
  const continueWatching = continueWatchingConfig[profile];

  return (
    <div className="continue-watching-row">
      <h2 className="row-title">Continue Watching for {profile.charAt(0).toUpperCase() + profile.slice(1)}</h2>
      <div className="card-row">
        {continueWatching.map((pick, index) => (
          <Link to={pick.link} key={index} className="pick-card">
            <img src={pick.imgSrc} alt={pick.title} className="pick-image" />
            <div className="overlay">
              <div className="pick-label">{pick.title}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ContinueWatching;
